module.exports = __webpack_public_path__ + "static/sel__icon-cae2c6fd2efac332cc37dc9bd82701b8.svg";